export default __webpack_public_path__ + "static/media/strategik3.2a9d049a.jpg";